import { IDeclaredValueResponse } from "@/entities";
import { APPLICATION_JSON } from "@/constans";
import { handleResponse } from "@/services/handlers";
import {
  BACKEND_BASE_URL,
  IDeleteDeclaredValueRequestBody,
  IGetDeclaredValueParams,
  IGetProductsParams,
  IResponseError,
  ISaveDeclaredValuePackRequestBody,
  ISaveDeclaredValueRequestBody,
  ISolServiceApi,
  ISolServiceProductsResponse,
} from "@/services";
import Vue from "vue";

export class SolServiceApi implements ISolServiceApi {
  async deleteDeclaredValue(body: IDeleteDeclaredValueRequestBody): Promise<boolean> {
    const headers: Record<string, string> = {
      Accept: APPLICATION_JSON,
    };

    const { error } = await handleResponse<Promise<void>, IResponseError>(
      Vue.$axios.delete(`${BACKEND_BASE_URL}/api/sol-service/v1/declared-value`, {
        headers,
        data: body,
      })
    );

    return !error;
  }

  async getDeclaredValues(
    params: IGetDeclaredValueParams
  ): Promise<IDeclaredValueResponse | undefined> {
    const headers: Record<string, string> = {
      Accept: APPLICATION_JSON,
    };

    const { response, error } = await handleResponse<
      Promise<IDeclaredValueResponse | undefined>,
      IResponseError
    >(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/sol-service/v2/declared-value`, {
        headers,
        params,
      })
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async saveDeclaredValue(body: ISaveDeclaredValueRequestBody): Promise<boolean> {
    const headers: Record<string, string> = {
      Accept: APPLICATION_JSON,
    };

    const { error } = await handleResponse<void, IResponseError>(
      Vue.$axios.post(`${BACKEND_BASE_URL}/api/sol-service/v1/declared-value`, body, {
        headers,
      })
    );

    return !error;
  }

  async saveDeclaredValuePack(body: ISaveDeclaredValuePackRequestBody): Promise<boolean> {
    const headers: Record<string, string> = {
      Accept: APPLICATION_JSON,
    };

    const { error } = await handleResponse<void, IResponseError>(
      Vue.$axios.post(`${BACKEND_BASE_URL}/api/sol-service/v1/declared-value-pack`, body, {
        headers,
      })
    );

    return !error;
  }

  async updateDeclaredValue(body: ISaveDeclaredValueRequestBody): Promise<boolean> {
    const headers: Record<string, string> = {
      Accept: APPLICATION_JSON,
    };

    const { error } = await handleResponse<void, IResponseError>(
      Vue.$axios.put(`${BACKEND_BASE_URL}/api/sol-service/v1/declared-value`, body, {
        headers,
      })
    );

    return !error;
  }

  async updateDeclaredValuePack(body: ISaveDeclaredValuePackRequestBody): Promise<boolean> {
    const headers: Record<string, string> = {
      Accept: APPLICATION_JSON,
    };

    const { error } = await handleResponse<void, IResponseError>(
      Vue.$axios.put(`${BACKEND_BASE_URL}/api/sol-service/v1/declared-value-pack`, body, {
        headers,
      })
    );

    return !error;
  }

  async getProducts(params: IGetProductsParams): Promise<ISolServiceProductsResponse | undefined> {
    const headers: Record<string, string> = {
      Accept: APPLICATION_JSON,
    };

    const { response, error } = await handleResponse<
      Promise<ISolServiceProductsResponse | undefined>,
      IResponseError
    >(
      Vue.$axios.get(
        `${BACKEND_BASE_URL}/api/sol-service/v1/products/service-points/${params.countryCode}/${params.servicePointId}`,
        {
          headers,
        }
      )
    );

    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }
}
